import { render, staticRenderFns } from "./examen-bio-modal.html?vue&type=template&id=38803ed3&scoped=true&external"
import script from "./examen-bio-modal.js?vue&type=script&lang=js&external"
export * from "./examen-bio-modal.js?vue&type=script&lang=js&external"
import style0 from "./examen-bio-modal.scss?vue&type=style&index=0&id=38803ed3&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38803ed3",
  null
  
)

export default component.exports